import { Box, Typography } from "@mui/material";
import error404 from "../assets/images/maintenance/Error404.png";

export const NotFound = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100vh",
        flexGrow: 1,
        backgroundColor: "lightgrey",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          margin: "auto",
        }}
      >
        <Box
          sx={{
            width: { xs: 250, sm: 590 },
            height: { xs: 130, sm: 300 },
          }}
        >
          <img
            src={error404}
            alt="mantis"
            style={{ width: "100%", height: "100%" }}
          />
        </Box>
        <Typography variant={"h2"}>Page not found</Typography>
      </Box>
    </Box>
  );
};
